import { BaseModel } from '@/app/modules/base/BaseModel';
import { Method } from 'axios';

/**
 * @deprecated legacy
 */
export class Request extends BaseModel {
  static GET: Method = 'get';
  static POST: Method = 'post';
  static PUT: Method = 'put';
  static DELETE: Method = 'delete';
  static targets = {
    SVC: 'service', // Сервис
    BITRIX: 'bitrix', // Бус
    LANDER: 'lander', // Лэндер
    FIXTURE: 'fixture', // Фикстуры
  }

  constructor(
    readonly url: string,
    readonly method: Method,
    readonly target: string = 'service',
    readonly headers?: Record<string, string>,
    readonly params?: Record<string, any>,
    readonly body?: Record<string, any>,
  ) {
    super();
  }
}
